import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import { createVNode, createComponentVNode, normalizeProps } from "inferno";
import { Component } from 'inferno';
import { safeGet } from 'safe-utils';
import classnames from 'classnames';
import getWidgetAdapters from './getWidgetAdapters';

function renderFormRows(_ref) {
  var schema = _ref.schema,
      value = _ref.value,
      selectFields = _ref.selectFields,
      omitFields = _ref.omitFields,
      lang = _ref.lang,
      validationErrors = _ref.validationErrors,
      namespace = _ref.namespace,
      inputName = _ref.inputName,
      isMounted = _ref.isMounted,
      customWidgets = _ref.customWidgets,
      onInput = _ref.onInput,
      onChange = _ref.onChange;
  var renderFields = Object.keys(schema._fields);
  var dottedNamespace = Array.isArray(namespace) ? namespace.join('.') : '';

  if (Array.isArray(selectFields) && selectFields.length > 0) {
    renderFields = renderFields.filter(function (key) {
      var dottedName = dottedNamespace ? "".concat(dottedNamespace, ".").concat(key) : key;
      var tmp = selectFields.filter(function (sel) {
        return sel === dottedName || sel.startsWith(dottedName + '.');
      });
      return tmp.length > 0;
    }); // Remove root level props so they aren't counted when we pass on to next level
    // so we can select all if none are passed

    selectFields = selectFields.filter(function (key) {
      return key.indexOf('.') >= 0;
    });
  }

  if (Array.isArray(omitFields)) {
    renderFields = renderFields.filter(function (key) {
      var dottedName = dottedNamespace ? "".concat(dottedNamespace, ".").concat(key) : key;
      return omitFields.indexOf(dottedName) < 0;
    });
  }

  var widgetAdapters = renderFields.map(function (key) {
    // Call the validationConstraint methods to figure out if the field should be validated
    var shouldValidate = schema._validationConstraints.reduce(function (prev, curr) {
      return prev && curr(value, key);
    }, true);

    if (!shouldValidate) {
      // Don't render fields that shouldn't be validated
      return;
    }

    var field = schema._fields[key];
    var validationError = safeGet(function () {
      return validationErrors && validationErrors.fieldErrors && validationErrors.fieldErrors[key];
    });
    var myNamespace = namespace.concat([key]); // .concat returns a new array

    var dotName = myNamespace.join('.'); // Unpack the invariant errors so they can be found by field key

    var tmpInvariantErrors = safeGet(function () {
      return validationErrors && validationErrors.invariantErrors && validationErrors.invariantErrors.filter(function (invErr) {
        // Pattern match field name of error with current namespace to see if it is a match
        return invErr.fields.reduce(function (prev, curr) {
          return prev || curr.indexOf(dotName) === 0;
        }, false);
      });
    });

    if (Array.isArray(tmpInvariantErrors) && tmpInvariantErrors.length > 0) {
      if (!validationError) validationError = {};
      validationError.invariantErrors = tmpInvariantErrors;
    }

    var _getWidgetAdapters = getWidgetAdapters(field, myNamespace.join('.'), customWidgets),
        InputFieldAdapter = _getWidgetAdapters.InputFieldAdapter,
        RowAdapter = _getWidgetAdapters.RowAdapter;

    return {
      validationError: validationError,
      propName: key,
      RowAdapter: RowAdapter,
      InputFieldAdapter: InputFieldAdapter
    };
  }); // Remove undefined widgets

  widgetAdapters = widgetAdapters.filter(function (item) {
    return item;
  });
  var widgets = widgetAdapters.map(function (_ref2) {
    var RowAdapter = _ref2.RowAdapter,
        InputFieldAdapter = _ref2.InputFieldAdapter,
        propName = _ref2.propName,
        validationError = _ref2.validationError;
    var Row = RowAdapter.Component;
    var InputField = InputFieldAdapter.Component;
    var doesNotRenderLabel = RowAdapter.doesNotRenderLabel();
    var myNamespace = namespace.concat([propName]); // .concat returns a new array

    var newInputName = inputName && propName ? inputName + '[' + propName + ']' : inputName || propName;
    var myId = myNamespace.join('.');
    var sharedProps = {
      id: myId,
      namespace: myNamespace,
      doesNotRenderLabel: doesNotRenderLabel,
      propName: propName,
      value: value && value[propName],
      options: {
        parentValue: value,
        lang: lang
      },
      validationError: validationError,
      formIsMounted: isMounted,
      // Callbacks
      onChange: onChange,
      onInput: onInput // TODO: Key should be namespace parent.propName

    };
    return normalizeProps(createComponentVNode(2, Row, _objectSpread({
      "adapter": RowAdapter
    }, sharedProps, {
      children: normalizeProps(createComponentVNode(2, InputField, _objectSpread({
        "adapter": InputFieldAdapter,
        "inputName": newInputName,
        "customWidgets": customWidgets,
        "selectFields": selectFields,
        "omitFields": omitFields
      }, sharedProps)))
    }), myNamespace.join('.')));
  });
  return widgets;
}

var FormRows = /*#__PURE__*/function (_Component) {
  _inherits(FormRows, _Component);

  function FormRows() {
    _classCallCheck(this, FormRows);

    return _possibleConstructorReturn(this, _getPrototypeOf(FormRows).apply(this, arguments));
  }

  _createClass(FormRows, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      // I need this to pass to rows in order to avoid animations on first render
      this.isMounted = true;
    }
  }, {
    key: "getChildContext",
    value: function getChildContext() {
      // Pass along the existing context
      var outp = {};

      for (var k in this.context) {
        outp[k] = this.context[k];
      } // And add our extra helpers


      outp['renderHelpAsHtml'] = this.props.renderHelpAsHtml || this.context.renderHelpAsHtml || false;

      if (!this.context.hasOwnProperty('rootValue')) {
        outp['rootValue'] = this.props.value;
      }

      return outp;
    }
  }, {
    key: "render",
    value: function render() {
      var customWidgetDict = {};

      if (this.props.children) {
        var children = Array.isArray(this.props.children) ? this.props.children : [this.props.children];
        children.forEach(function (widget) {
          customWidgetDict[widget.props.propPath] = {
            fieldWidget: widget.props.fieldWidget,
            rowWidget: widget.props.rowWidget
          };
        });
      } // TODO: We should remove onInput and pass all changes down the chain to onChange


      return createVNode(1, "div", classnames('InfernoFormlib-FormRows', this.props.className), renderFormRows({
        schema: this.props.schema,
        namespace: this.props.namespace || [],
        inputName: this.props.inputName,
        value: this.props.value,
        selectFields: typeof this.props.selectFields === 'string' ? this.props.selectFields.split(',').map(function (k) {
          return k.trim();
        }) : this.props.selectFields,
        omitFields: typeof this.props.omitFields === 'string' ? this.props.omitFields.split(',').map(function (k) {
          return k.trim();
        }) : this.props.omitFields,
        lang: this.props.lang,
        validationErrors: this.props.validationErrors,
        isMounted: this.isMounted,
        customWidgets: customWidgetDict,
        onInput: this.props.onInput,
        onChange: this.props.onChange
      }), 0);
    }
  }]);

  return FormRows;
}(Component);

export { FormRows, renderFormRows };